<script>
import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  mounted() {
    this.renderChart(
      {
        labels: [""
          ,
          "Kurum İçi",
          "Kurum Dışı",
          
        ],
        datasets: [
          {
            label: "Gelir TL",
            backgroundColor: "#ee313a",
            data: [0,20, 30],
          }
        ]
      },
      { responsive: true, maintainAspectRatio: false, scales: {
          xAxes: [{
              barThickness: 7,
          }]
          } }
    );
  }
};
</script>
